import { render, staticRenderFns } from "./back-top.vue?vue&type=template&id=1ecb7d78&scoped=true&"
import script from "./back-top.vue?vue&type=script&lang=js&"
export * from "./back-top.vue?vue&type=script&lang=js&"
import style0 from "./back-top.vue?vue&type=style&index=0&id=1ecb7d78&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb7d78",
  null
  
)

export default component.exports